export default __webpack_public_path__ + "static/media/screen5.0d5cae4c.png";